<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}} <br><a href="https://docs.justwash.asia/tutorial/promotions" style="color: #007aff; font-size: 14px;   font-weight: 400;" target="_blank">View tutorial</a>
          </h3>
        </div>

         <div class="col text-right">
          <a class="btn btn-primary" type="button" v-bind:href="'#/setting-promotion/'+ null" >เพิ่มโปรโมชัน</a>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <!-- <th class="text-center" style="font-size: 14px;">รหัสเครื่อง</th>
          <th class="text-center" style="font-size: 14px;">ชื่อเครื่อง</th> -->
          <!-- <th class="text-center" style="font-size: 14px;">ราคาปกติ</th> -->
          <th class="text-center " style="font-size: 14px;">โปรโมชัน</th>
          <th class="text-center" style="font-size: 14px;">สถานะ</th>
          <th class="text-center" style="font-size: 14px;">เปิด/ปิด</th>
          <th class="text-center" style="font-size: 14px;">ตั้งค่า</th>
          <!-- <th class="text-center" style="font-size: 14px; padding: -20px;">ลบโปรโมชัน</th> -->

          
        </template>
    

        <template slot-scope="{row}">
        
          <td class="text-center">
            {{row.promotion_name}}
          </td>

          <td class="budget text-center">
               <b v-if="row.enable === true" style="color: green"> กำลังใช้งาน </b>
               <b v-if="row.enable === false" style="color: gray"> ปิดใช้งาน </b>
          </td>

          <td class="budget text-center">
              
               <base-switch 
                        :value="row.enable" 
                        class="ml-1" 
                        @input="row.enable = Boolean($event)" 
                        v-on:click="booleanData(row.name , row.enable)"
                        >
               </base-switch>
              
          </td>

          <td class="text-center">
            <a class="btn btn-outline-primary" v-bind:href="'#/setting-promotion/'+ row.name" >
              <i class="ni ni-settings"></i>
           </a>
          <a class="btn btn-outline-warning" v-on:click="confirmDelete(row.name)">
              <i class="ni ni-fat-remove" ></i>
           </a> 
              
           <!-- <base-button size="sm" block type="outline-primary" v-bind:href="'#/setting-promotion/'+ row.name">
           <i class="ni ni-settings"></i>
           </base-button>
           <base-button size="sm" block type="outline-warning" v-on:click="confirmDelete()">
                <i class="ni ni-fat-remove"></i>
           </base-button> -->

           </td> 

        
      
        </template>
       
      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
    </div>

    
  </div>
</template>
<script>
//   import * as firebase from 'firebase';

  import JwService from '../../service/justwash';
  import axios from 'axios'
//   Your web app's Firebase configuration
//   var firebaseConfig = {
//     apiKey: "AIzaSyCUaLVCX3LU7eQcHhgeY-sAsBhRqlZlieI",
//     authDomain: "justwash-api.firebaseapp.com",
//     databaseURL: "https://justwash-api.firebaseio.com",
//     projectId: "justwash-api",
//     storageBucket: "justwash-api.appspot.com",
//     messagingSenderId: "1043115702649",
//     appId: "1:1043115702649:web:17296f85b68c54a57817a8"
//   };
  // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);

//   var database = firebase.database()
//   var deviceRef = database.ref('/devices')

  export default {
    name: 'promotion-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        tableData: [],
        devices: {}, 
 
      }
    },
      methods:{
        async confirmDelete(data) {
                // console.log(data);
                let r = confirm("ยืนยันการลบโปรโมชัน");
                if (r === true) {
                    // console.log('delete');
                 await  axios({
                        method: 'post',
                        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.delete_promotion',
                        data: {
                            name: data
                        },
                        headers: {
                        'Authorization' : 'Token '+localStorage.getItem('accessToken')
                        }
                    }).then((response) => {
                        if (response.data.message.status == true) {
                        //   deviceRef.on('value', (snapshot) => {
                            // this.devices = snapshot.val();
                            this.tableData = response.data.message.data;

                            for (let index = 0; index < this.tableData.length; index++) {
                                if (this.tableData[index].enable === 1) {
                                    this.tableData[index].enable = true;
                                } else {
                                    this.tableData[index].enable = false;
                                }
                                }
                                //  console.log( this.tableData);
                                }
                            }).catch(error => {
                                /* eslint-disable no-console */
                                console.log(error);
                            });

                } 
            },
        booleanData(data1, data2) {
            // console.log(data1, data2);
            let enable;

           if (data2 === true) {
                enable = 0
            } else  {
                enable = 1
            }
            // console.log('enable', enable);
                 
                    axios({
                        method: 'post',
                        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.enable_promotion',
                        data: {
                            name: data1,
                            enable : enable
                        },
                        headers: {
                        'Authorization' : 'Token '+localStorage.getItem('accessToken')
                        }
                      }).then((response) => {
                         if (response.data.message.status == true) {
                            console.log(response.data.message.data);
                            this.tableData = response.data.message.data;
                            for (let index = 0; index < this.tableData.length; index++) {
                                if (this.tableData[index].enable === 1) {
                                    this.tableData[index].enable = true;
                                } else {
                                    this.tableData[index].enable = false;
                                }
                                }
                
                         }
                        }).catch(error => {
                             console.log(error);
                        });
        },
      async getPromotion(){
          await  axios({
                        method: 'post',
                        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.get_promotions',
                        data: {},
                        headers: {
                        'Authorization' : 'Token '+localStorage.getItem('accessToken')
                        }
                    }).then((response) => {
                        if (response.data.message.status == true) {
                        //   deviceRef.on('value', (snapshot) => {
                            // this.devices = snapshot.val();
                            this.tableData =  response.data.message.data;
                            // console.log( this.tableData);
                            for (let index = 0; index < this.tableData.length; index++) {
                                if (this.tableData[index].enable === 1) {
                                    this.tableData[index].enable = true;
                                } else {
                                    this.tableData[index].enable = false;
                                }
                            }
                        }
                }).catch(error => {
                    console.log(error);
                    // this.$router.push('/login');
                });
             }
    },
   async mounted() {
          await this.getPromotion();
    }
  }
</script>
<style>
</style>
